import React from 'react'
import { v4 as uuidv4 } from 'uuid'

const Footer = () => {
    return (
        <footer id="contact-me" className=" container d-flex justify-content-center">
          
            <address className="contact-info">
                <ul className="row">
                 
                    <li className="col-3 mediaIcon">
                        <p><a href="mailto: cory.c.calaway@gmail.com">
                        <img src={require(`../assets/images/email.svg`).default}
                                alt='Email'
                                key={uuidv4()}
                            />
                        
                        </a></p>
                    </li>
                    <li className="col-3 mediaIcon">
                        <p><a href="https://github.com/corycalaway/">
                            <img src={require(`../assets/images/github1.svg`).default}
                                alt='GitHub'
                                key={uuidv4()}

                            />
                        </a></p>
                    </li>
                    <li className="col-3 mediaIcon">
                        <p><a href="https://twitter.com/CoryCalaway">
                            <img src={require(`../assets/images/twitter.svg`).default}
                                alt='Twitter'
                                key={uuidv4()}
                            />
                        </a></p>
                    </li>
                    <li className="col-3 mediaIcon">
                        <p><a href="https://www.linkedin.com/in/calawaycory">
                        <img src={require(`../assets/images/linkedin.svg`).default}
                                alt='LinkedIN'
                                key={uuidv4()}
                            />
                            </a></p>
                    </li>
                </ul>
            </address>

        </footer>
    )
}

export default Footer
